import React, { Component, ReactElement } from 'react';

import PollingChart from 'buyside/components/presentation/Charts/PollingChart/pollingChart';
import PollingTable from 'buyside/components/presentation/CompanyPoll/PollResults/ResultTable/pollingTable';
import { CompanyQuestion } from 'buyside/components/container/CompanyShow/BuysideConsensusContainer';

import {
  combineAndFormatPollResults,
  CombinedMonthlyResults,
  LabelValueObject
} from 'buyside/components/container/CompanyShow/pollResultsUtil';

import { Maybe } from 'interfaces/graphql-typings';
type GraphTableProps = {
  question: CompanyQuestion;
  chartId: Maybe<string>;
};
class PollResultVisualsContainer extends Component<GraphTableProps> {
  constructor(props: GraphTableProps) {
    super(props);
  }

  sortData(arr: LabelValueObject[]): LabelValueObject[] {
    return [...arr].sort((a, b): number => {
      if (a.value < b.value) {
        return 1;
      } else if (a.value > b.value) {
        return -1;
      }
      return 0;
    });
  }

  render(): ReactElement {
    const {
      id,
      yMin,
      yMax,
      tickCount,
      showTooltip,
      tickValues,
      name,
      pollResponseData: { buysidePollResultStats, retailPollResultStats }
    } = this.props.question;

    const formattedBuysideRetailMonthlyAverage = combineAndFormatPollResults(
      buysidePollResultStats?.monthlyAvg || [],
      retailPollResultStats?.monthlyAvg || []
    );

    const formattedBuysideRetailLTM = combineAndFormatPollResults(
      buysidePollResultStats?.twelveMonthsPct || [],
      retailPollResultStats?.twelveMonthsPct || []
    );

    const formattedBuysideRetailCurrentMonth = combineAndFormatPollResults(
      buysidePollResultStats?.currentMonthPct || [],
      retailPollResultStats?.currentMonthPct || []
    );

    return tickCount ? (
      <PollingChart
        columns={Object.keys(formattedBuysideRetailMonthlyAverage).map(
          (key): CombinedMonthlyResults => formattedBuysideRetailMonthlyAverage[key]
        )}
        questionId={id}
        tickCount={tickCount}
        tickFormat={tickValues}
        tooltipShow={Boolean(showTooltip)}
        yMax={yMax}
        yMin={yMin}
      />
    ) : (
      <PollingTable
        questionName={name}
        lastTwelveMonths={formattedBuysideRetailLTM}
        currentMonths={formattedBuysideRetailCurrentMonth}
      />
    );
  }
}

export default PollResultVisualsContainer;
